export const getCleanHydraId = (id) => {
  return id.split('/').slice(-1)[0]
}